/* 画像ツールバーに画像のパス（URL）を表示＆クリップボードへコピーする機能を提供するプラグイン */
class PathForImageToolbar {
  constructor(editor) {
    this.editor = editor;
    this.containerId = 'image-toolbar-information';
    this.resourceTypes = [];
  }

  init() {
    this.getCkfinderResourceType();
    this.editor.editing.view.document.on('mousedown', (evt, data) => {
      if (document.querySelector(`#${this.containerId}`)) {
        document.querySelector(`#${this.containerId}`).remove();
      }
    });
    this.editor.editing.view.document.on('click', (evt, data) => {
      const target = data.domTarget;
      if (target && target.nodeName === 'IMG') {
        this.setContent(target);
      }
    });
  }

  setContent(imageElement) {
    const toolbarElement = document.querySelector('.ck-balloon-rotator__content');
    const toolbarContainerElement = toolbarElement.parentElement;
    // Container
    const contentContainerElement = document.createElement('div');
    contentContainerElement.id = this.containerId;
    // Input
    const inputElement = document.createElement('input');
    const inputValue = this.getInputValue(imageElement);
    inputElement.setAttribute('type', 'text');
    inputElement.value = inputValue;
    inputElement.readOnly = true;
    inputElement.style.width = '300px';
    inputElement.style.margin = '2px 5px 10px 5px';
    inputElement.style.padding = '2px 7px';
    inputElement.style.borderRadius = '4px';
    inputElement.style.border = '1px solid #ccc';
    // Button
    const buttonElement = document.createElement('button');
    buttonElement.innerHTML = this.editor.i18n.t('コピー');
    buttonElement.style.color = '#333';
    buttonElement.style.margin = '2px 5px 10px 1px';
    buttonElement.style.padding = '2px 5px';
    buttonElement.style.borderRadius = '4px';
    buttonElement.style.border = '1px solid #ccc';
    buttonElement.style.backgroundColor = '#fff';
    buttonElement.addEventListener('click', () => {
      inputElement.select();
      buttonElement.style.color = '#fff';
      buttonElement.style.backgroundColor = '#108c00';
      buttonElement.innerHTML = '&#x2714;' + this.editor.i18n.t('コピー');
      setTimeout(() => {
        buttonElement.style.color = '#333';
        buttonElement.style.backgroundColor = '#fff';
        buttonElement.innerHTML = this.editor.i18n.t('コピー');
        inputElement.selectionStart = 0;
        inputElement.selectionEnd = 0;
      }, 1000);
      navigator.clipboard.writeText(inputValue);
    });
    contentContainerElement.appendChild(inputElement);
    contentContainerElement.appendChild(buttonElement);
    toolbarContainerElement.appendChild(contentContainerElement);
  }

  getCkfinderResourceType() {
    const ckfinderOptions = this.editor.config.get('ckfinder.options');
    const connectorPath = ckfinderOptions.connectorPath;
    const connectorInfo = ckfinderOptions.connectorInfo;
    const url = `${connectorPath}?command=Init&${connectorInfo}`;
    const xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4 && xhr.status === 200) {
        const data = JSON.parse(xhr.responseText);
        this.resourceTypes = data.resourceTypes;
      }
    };
    xhr.send();
  }

  getInputValue(imageElement) {
    let inputValue = '';
    const imageSrc = imageElement.getAttribute('src');
    const rawUrl = imageSrc.startsWith('/') ? imageSrc : new URL(imageSrc).pathname;
    this.resourceTypes.forEach((resourceType) => {
      const resourceTypeUrl = resourceType.url;
      if (rawUrl.startsWith(resourceTypeUrl)) {
        const path = rawUrl.replace(resourceTypeUrl, '');
        inputValue = `${resourceType.name}:${path}`;
        return;
      }
    });

    if (!inputValue) {
      inputValue = rawUrl;
    }

    return inputValue;
  }
}

export default PathForImageToolbar;
